import { message } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../api/client';

/** 帳號管理的變更動作（角色 / email）：桌機表格與手機卡片共用。 */
export function useUserMutations() {
  const qc = useQueryClient();
  const setRole = useMutation({
    mutationFn: (v: { id: string; roleId: string }) => api.setUserRole(v.id, v.roleId),
    onSuccess: () => {
      message.success('角色已更新');
      qc.invalidateQueries({ queryKey: ['users-manage'] });
    },
    onError: (e: Error) => message.error(e.message),
  });
  const setEmail = useMutation({
    mutationFn: (v: { id: string; email: string }) => api.setUserEmail(v.id, v.email),
    onSuccess: () => {
      message.success('Email 已更新（該使用者可用此 email 登入並連結帳號）');
      qc.invalidateQueries({ queryKey: ['users-manage'] });
    },
    onError: (e: Error) => message.error(e.message),
  });
  return {
    changeRole: (id: string, roleId: string) => setRole.mutate({ id, roleId }),
    changeEmail: (id: string, email: string) => setEmail.mutate({ id, email: email.trim() }),
  };
}
